module.exports = __webpack_public_path__ + "img/icon-decrease.2180a222.svg";